export const paths = {
  root: {
    path: '',
  },
  home: {
    path: '/',
    getHref: () => '/',
  },
  // Dupe/alias of `home` above
  welcome: {
    path: '/',
    getHref: () => '/',
  },

  signIn: {
    path: '/sign-in',
    getHref: () => '/sign-in',
  },

  verifyOtp: {
    path: '/verify-otp',
    getHref: () => '/verify-otp',
  },

  // auth: {
  //   register: {
  //     path: '/auth/register',
  //     getHref: (redirectTo?: string | null | undefined) =>
  //       `/auth/register${
  //         redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''
  //       }`,
  //   },
  //   login: {
  //     path: '/auth/login',
  //     getHref: (redirectTo?: string | null | undefined) =>
  //       `/auth/login${
  //         redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''
  //       }`,
  //   },
  // },

  flow: {
    root: {
      path: '/:formResponseReferenceId',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}`,
    },
    previouslyDiagnosed: {
      root: {
        path: '/:formResponseReferenceId/previously-diagnosed',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/previously-diagnosed`,
      },
      start: {
        path: '',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/previously-diagnosed`,
      },
      addDiagnoses: {
        path: 'update',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/previously-diagnosed/update`,
      },
    },

    geneticHistory: {
      root: {
        path: '/:formResponseReferenceId/genetic-history',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/genetic-history`,
      },
      start: {
        path: '',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/genetic-history`,
      },
      tests: {
        path: 'tests',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/genetic-history/tests`,
      },
      variants: {
        path: 'variants',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/genetic-history/variants`,
      },
    },

    labTests: {
      path: '/:formResponseReferenceId/lab-tests',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/lab-tests`,
    },

    symptomAssessment: {
      path: 'symptom-assessment',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/symptom-assessment`,
    },

    fewQuestions: {
      path: '/:formResponseReferenceId/few-questions',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/few-questions`,
    },
  },

  review: {
    root: {
      path: '/:formResponseReferenceId/review',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review`,
    },
    patientInfo: {
      path: '/:formResponseReferenceId/review/patient-info',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review/patient-info`,
    },
    contactInfo: {
      path: '/:formResponseReferenceId/review/contact-info',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review/contact-info`,
    },
    diagnoses: {
      path: '/:formResponseReferenceId/review/diagnoses',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review/diagnoses`,
    },
    labTests: {
      path: '/:formResponseReferenceId/review/lab-tests',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review/lab-tests`,
    },
    patientSymptoms: {
      path: '/:formResponseReferenceId/review/patient-symptoms',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review/patient-symptoms`,
    },
  },

  'not-found': {
    path: '/not-found',
    getHref: () => '/not-found',
  },

  dashboard: {
    root: {
      path: '/dashboard',
      getHref: () => '/dashboard',
    },
    status: {
      path: '',
      getHref: () => '/dashboard',
    },
    account: {
      path: 'account',
      getHref: () => '/dashboard/account',
    },
    patient: {
      path: 'patient',
      getHref: () => '/dashboard/patient',
    },
    diagnoses: {
      path: 'diagnoses',
      getHref: () => '/dashboard/diagnoses',
    },
    geneticTests: {
      path: 'genetic-tests',
      getHref: () => '/dashboard/genetic-tests',
    },
    labTests: {
      path: 'lab-tests',
      getHref: () => '/dashboard/lab-tests',
    },
    assessment: {
      path: 'assessment',
      getHref: () => '/dashboard/assessment',
    },
  },
} as const;
